var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline-event"},[_c('div',{staticClass:"timeline"},[_c('div',{staticClass:"icon"},[_vm._t("icon")],2),_c('div',{staticClass:"line"})]),_c('div',{staticClass:"event"},[_c('small',{staticClass:"name"},[_vm._v(_vm._s(_vm.formattedDate))]),_c('div',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }